import React, { useEffect, useState } from 'react';
import cl from './DealerCarPage.module.css'; 
import DownloadIcon from "../../../../assets/Icon/Download";
import { baseFileURL } from '../../../../Api'; 
import  Tabs, { Tab }  from '../../../../components/UI/Tabs/Tabs';
import { useTranslation } from 'react-i18next';

 

const DealerCarPhotos = ({carService, car }) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;     

    const [loadingImages, setLoadingImages] = useState([]);
    const [arrivalImages, setArrivalImages] = useState([]);
    const [buyImages, setBuyImages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [galleryImages, setGalleryImages] = useState([]);
    
    useEffect(() => {
        const fetchCarImages = async () => {
            try {
                if (car) {
                    setLoadingImages(car.images_obj?.loading || []);
                    setArrivalImages(car.images_obj?.arrival || []);
                    setBuyImages(car.images_obj?.buy || []);
                } else {
                    setError("No car found with the given ID.");
                }
            } catch (err) {
                setError(`Error fetching car details: ${err.message}`);
                console.error("Error fetching the car:", err);
            } finally {
                setIsLoading(false);
            }
        };

        if (car) {
            fetchCarImages();
        }
    }, [car]);

    const downloadImage = (name) => {
        if (carService && typeof carService.downloadFile === 'function') {
            carService.downloadFile(Number(car.id), name);
        } else {
            console.error("Car service or downloadFile function not available.");
        }
    };

    const openModal = (images, index) => {
        setCurrentImageIndex(index); // Set the clicked image index
        setGalleryImages(images); // Set the current gallery images
        setModalImage(images[index]); // Set the clicked image as modal image
        setIsModalOpen(true); // Open modal
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalImage(null);
    };

    const nextImage = () => {
        const newIndex = (currentImageIndex + 1) % galleryImages.length;
        setCurrentImageIndex(newIndex);
        setModalImage(galleryImages[newIndex]);
    };

    const prevImage = () => {
        const newIndex = (currentImageIndex - 1 + galleryImages.length) % galleryImages.length;
        setCurrentImageIndex(newIndex);
        setModalImage(galleryImages[newIndex]);
    };

    if (isLoading) {
        return <div>Loading images...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <>
 
            <div className={cl.boxMainPhoto}> 

                <Tabs initialIndex={0}>
                    <Tab label={t('PurchasePhotos')}> 
                            <div className={cl.colBoxPhoto}> 
                                <span className={cl.downBTN} onClick={() => downloadImage("buy")}>
                                    <DownloadIcon /> {t('Download')}
                                </span>
                                <div className={cl.containerPhoto}>
                                    {buyImages.length > 0 ? (
                                        buyImages.map((image, index) => (
                                            <div key={index} className={cl.image} onClick={() => openModal(buyImages, index)}>
                                                <img src={`${baseFileURL}${image}`} alt={`buy-image-${index}`} />
                                            </div>
                                        ))
                                    ) : (
                                        <div className={cl.noImage}>No Images</div>
                                    )}
                                </div>
                            </div> 
                    </Tab>
                    <Tab label={t('LoadingPhotos')}> 
                        <div className={cl.colBoxPhoto}> 
                            <span className={cl.downBTN} onClick={() => downloadImage("loading")}>
                                <DownloadIcon /> {t('Download')}
                            </span>
                            <div className={cl.containerPhoto}>
                                {loadingImages.length > 0 ? (
                                    loadingImages.map((image, index) => (
                                        <div key={index} className={cl.image} onClick={() => openModal(loadingImages, index)}>
                                            <img src={`${baseFileURL}${image}`} alt={`loading-image-${index}`} />
                                        </div>
                                    ))
                                ) : (
                                    <div className={cl.noImage}>No Images</div>
                                )}
                            </div>
                        </div>
                    </Tab>
                    <Tab label={t('ArrivalPhotos')}> 
                        <div className={cl.colBoxPhoto}> 
                            <span className={cl.downBTN} onClick={() => downloadImage("arrival")}>
                                <DownloadIcon /> {t('Download')}
                            </span>
                            <div className={cl.containerPhoto}>
                                {arrivalImages.length > 0 ? (
                                    arrivalImages.map((image, index) => (
                                        <div key={index} className={cl.image} onClick={() => openModal(arrivalImages, index)}>
                                            <img src={`${baseFileURL}${image}`} alt={`arrival-image-${index}`} />
                                        </div>
                                    ))
                                ) : (
                                    <div className={cl.noImage}>No Images</div>
                                )}
                            </div>
                        </div>
                    </Tab>
                </Tabs>

    
            </div> 

            {isModalOpen && (
                <div className={cl.modal} onClick={closeModal}>
                    <span className={cl.modalClose} onClick={closeModal}>
                        <svg aria-hidden="true" viewBox="0 0 24 24">
                            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 6 6 18M6 6l12 12"></path>
                        </svg>
                    </span>

                    <div className={cl.modalContent} onClick={(e) => e.stopPropagation()}>

                        {currentImageIndex > 0 && (
                            <button className={cl.modalNav + ' ' + cl.modalNavPrev} onClick={prevImage}>

                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M10 22L0 12L10 2l1.775 1.775L3.55 12l8.225 8.225z"/></svg>

                            </button>
                        )}
                        <img src={`${baseFileURL}${modalImage}`} alt="Modal" className={cl.modalImage} />

                        {currentImageIndex < galleryImages.length - 1 && (
                            <button className={cl.modalNav + ' ' + cl.modalNavNext} onClick={nextImage}>
                                
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M10 22L0 12L10 2l1.775 1.775L3.55 12l8.225 8.225z"/></svg>

                            </button>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default DealerCarPhotos;